module.exports = __webpack_public_path__ + "static/creation-flowchart-4f32dcb6de28a181c2ef91fa10e86d31.png";